(function () {
  window.rdvdeco = window.rdvdeco || {};

  var LIFESTYLE_CLASS = 'product__breadcrumbs--lifestyle';
  var MEASURING_CLASS = 'product__breadcrumbs--measuring';
  var SCRIM_CLASS = 'product__breadcrumbs--scrim';
  /* Cible de contraste du voile. 4.5:1 serait WCAG AA pour du texte normal, mais
     le voile devenait trop visible sur les fonds tres contrastes. 3:1 reste un
     seuil WCAG (grand texte, composants d'interface) : choix assume, defendable
     pour une navigation secondaire dont les liens existent ailleurs sur la page.
     Baisser cette valeur allege le voile sur TOUS les produits, et en supprime
     l'apparition sur ceux qui se situent desormais au-dessus du seuil. */
  var TARGET_RATIO = 3;
  var MAX_SCRIM_ALPHA = 0.6;
  var MIN_SCRIM_ALPHA = 0.04;
  /* Doit rester aligne sur le width du <link rel="preload"> pose par
     main-product.liquid, sinon la vignette est retelechargee. */
  var SAMPLE_WIDTH = 160;
  var REVEAL_TIMEOUT = 1200;
  var desktop = window.matchMedia('(min-width: 768px)');
  var cache = {};

  function srgbToLinear(channel) {
    var c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }

  function relativeLuminance(r, g, b) {
    return 0.2126 * srgbToLinear(r) + 0.7152 * srgbToLinear(g) + 0.0722 * srgbToLinear(b);
  }

  function contrastRatio(a, b) {
    return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
  }

  function parseColor(value) {
    var input = (value || '').trim();
    if (!input) return null;

    if (input.charAt(0) === '#') {
      var hex = input.slice(1);
      if (hex.length === 3) {
        return [0, 1, 2].map(function (i) {
          return parseInt(hex[i] + hex[i], 16);
        });
      }
      if (hex.length >= 6) {
        return [0, 2, 4].map(function (i) {
          return parseInt(hex.slice(i, i + 2), 16);
        });
      }
      return null;
    }

    var parts = input.match(/-?\d+(?:\.\d+)?/g);
    if (!parts || parts.length < 3) return null;
    return [Number(parts[0]), Number(parts[1]), Number(parts[2])];
  }

  /* Les deux couleurs candidates sont lues sur le DOM plutot que codees en dur,
     pour rester alignees sur les reglages de couleur de l'admin. */
  function toneLuminances(container, sample) {
    var wasLifestyle = container.classList.contains(LIFESTYLE_CLASS);

    container.classList.remove(LIFESTYLE_CLASS);
    var dark = parseColor(window.getComputedStyle(sample).color);

    container.classList.add(LIFESTYLE_CLASS);
    var light = parseColor(window.getComputedStyle(sample).color);

    container.classList.toggle(LIFESTYLE_CLASS, wasLifestyle);

    if (!dark || !light) return null;
    return {
      dark: relativeLuminance(dark[0], dark[1], dark[2]),
      light: relativeLuminance(light[0], light[1], light[2]),
    };
  }

  function thumbnailUrl(src) {
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', String(SAMPLE_WIDTH));
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function clamp(value) {
    return Math.min(1, Math.max(0, value));
  }

  function overlapRegion(container, mediaItem) {
    var overlay = container.getBoundingClientRect();
    var media = mediaItem.getBoundingClientRect();
    if (!overlay.width || !overlay.height || !media.width || !media.height) return null;

    return {
      x: clamp((overlay.left - media.left) / media.width),
      y: clamp((overlay.top - media.top) / media.height),
      width: clamp(overlay.width / media.width),
      height: clamp(overlay.height / media.height),
    };
  }

  function measure(url, region) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';

      image.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;

          var context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0);

          var x = Math.min(canvas.width - 1, Math.round(region.x * canvas.width));
          var y = Math.min(canvas.height - 1, Math.round(region.y * canvas.height));
          var width = Math.max(1, Math.min(canvas.width - x, Math.round(region.width * canvas.width)));
          var height = Math.max(1, Math.min(canvas.height - y, Math.round(region.height * canvas.height)));

          var pixels = context.getImageData(x, y, width, height).data;
          var luminances = [];

          for (var i = 0; i < pixels.length; i += 4) {
            luminances.push({
              luminance: relativeLuminance(pixels[i], pixels[i + 1], pixels[i + 2]),
              rgb: [pixels[i], pixels[i + 1], pixels[i + 2]],
            });
          }

          if (!luminances.length) {
            reject(new Error('empty sample'));
            return;
          }

          /* Une moyenne ne dit rien d'un fond texture : un mur de pierre peut
             etre a 0.31 de moyenne tout en allant du quasi-noir au quasi-blanc.
             On garde les extremes, avec leur RGB, pour raisonner sur le pire cas
             et pour pouvoir y appliquer un voile. */
          luminances.sort(function (a, b) {
            return a.luminance - b.luminance;
          });

          resolve({
            low: luminances[Math.floor(0.05 * (luminances.length - 1))],
            high: luminances[Math.floor(0.95 * (luminances.length - 1))],
          });
        } catch (error) {
          reject(error);
        }
      };

      image.onerror = function () {
        reject(new Error('image load failed'));
      };

      image.src = url;
    });
  }

  /* Plus petite opacite de voile qui ramene ce pixel de fond au-dessus de la
     cible de contraste.
     Recherche dichotomique : le compositing n'est pas inversible analytiquement
     puisque la luminance relative n'est pas lineaire en sRGB. */
  function requiredAlpha(rgb, veil, textLuminance) {
    var bare = relativeLuminance(rgb[0], rgb[1], rgb[2]);
    if (contrastRatio(bare, textLuminance) >= TARGET_RATIO) return 0;

    var low = 0;
    var high = MAX_SCRIM_ALPHA;

    for (var i = 0; i < 24; i++) {
      var mid = (low + high) / 2;
      var blended = [
        rgb[0] * (1 - mid) + veil * mid,
        rgb[1] * (1 - mid) + veil * mid,
        rgb[2] * (1 - mid) + veil * mid,
      ];
      if (contrastRatio(relativeLuminance(blended[0], blended[1], blended[2]), textLuminance) < TARGET_RATIO) {
        low = mid;
      } else {
        high = mid;
      }
    }

    return high;
  }

  function reveal(container) {
    container.classList.remove(MEASURING_CLASS);
  }

  function refresh(container, initial) {
    if (!desktop.matches) {
      if (initial) reveal(container);
      return;
    }

    var gallery = container.closest('media-gallery');
    var mediaItem = gallery && gallery.querySelector('.product__media-item');
    var sample = container.querySelector('.breadcrumbs--last');
    if (!mediaItem || !sample) {
      if (initial) reveal(container);
      return;
    }

    /* Au premier passage on vise l'URL prechargee par Liquid, pour repartir du
       cache plutot que d'ouvrir une seconde requete. */
    var source = initial && container.dataset.sampleSrc ? container.dataset.sampleSrc : mediaItem.dataset.src;
    var url = thumbnailUrl(source);
    var region = overlapRegion(container, mediaItem);
    var tones = url && region ? toneLuminances(container, sample) : null;

    if (!tones) {
      if (initial) reveal(container);
      return;
    }

    var cached = cache[url];
    var pending = cached ? Promise.resolve(cached) : measure(url, region);

    pending
      .then(function (background) {
        cache[url] = background;

        /* Pire cas de chaque teinte : l'extreme du fond le plus proche d'elle. */
        var worstDark = Math.min(
          contrastRatio(background.low.luminance, tones.dark),
          contrastRatio(background.high.luminance, tones.dark)
        );
        var worstLight = Math.min(
          contrastRatio(background.low.luminance, tones.light),
          contrastRatio(background.high.luminance, tones.light)
        );

        var preferLight = worstLight > worstDark;
        container.classList.toggle(LIFESTYLE_CLASS, preferLight);

        /* Meme la meilleure des deux teintes peut echouer sur un fond contraste :
           seul un voile rend alors le contraste maitrisable. Son opacite est la
           plus faible qui atteigne TARGET_RATIO sur CE fond, pas une valeur fixe :
           un fond a peine texture reste presque transparent. */
        var textLuminance = preferLight ? tones.light : tones.dark;
        var veil = preferLight ? 0 : 255;
        var alpha = Math.max(
          requiredAlpha(background.low.rgb, veil, textLuminance),
          requiredAlpha(background.high.rgb, veil, textLuminance)
        );

        if (alpha > MIN_SCRIM_ALPHA) {
          container.style.setProperty('--breadcrumbs-scrim-alpha', alpha.toFixed(3));
          container.classList.add(SCRIM_CLASS);
        } else {
          container.classList.remove(SCRIM_CLASS);
          container.style.removeProperty('--breadcrumbs-scrim-alpha');
        }
      })
      .catch(function () {
        /* On conserve la classe posee par Liquid. */
      })
      .then(function () {
        if (initial) reveal(container);
      });
  }

  function watch(container) {
    /* Masque pose par JS : sans JS le fil d'Ariane s'affiche normalement. */
    container.classList.add(MEASURING_CLASS);
    setTimeout(function () {
      reveal(container);
    }, REVEAL_TIMEOUT);

    refresh(container, true);

    var gallery = container.closest('media-gallery');
    var mediaList = gallery && gallery.querySelector('.product__media-list');

    /* Choisir une variante fait remonter son visuel en premiere position
       (media-gallery.js, sortMediaItems) : le fond change, on remesure.
       Sans masquage cette fois, le fil d'Ariane est deja lisible a l'ecran. */
    if (mediaList) {
      new MutationObserver(function () {
        refresh(container, false);
      }).observe(mediaList, { childList: true });
    }

    var onChange = function () {
      refresh(container, false);
    };
    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', onChange);
    } else {
      desktop.addListener(onChange);
    }
  }

  function init() {
    document.querySelectorAll('.product__breadcrumbs').forEach(watch);
  }

  window.rdvdeco.breadcrumbsTone = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
